import React, { useEffect, useMemo, useState } from "react";
import { Support } from "../../pages";
import {
  BusinessController,
  SupportController,
  UserController,
} from "../../controllers";
import { toJS } from "mobx";
import { supportStore } from "../../stores";

const SupportContainer = () => {
  const [loading, setLoading] = useState(false);
  const [ViewMoreModal, setViewMoreModal] = useState(false);
  const [createSupportModal, setCreateSupportModal] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const supportsTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = SupportController.useGetSupports(
    supportsTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const goToViewMoreModal = () => {
    setViewMoreModal(true);
  };
  const goToCreateSupport = () => {
    setCreateSupportModal(true);
  };

  const closeModal = () => {
    setViewMoreModal(false);
    setCreateSupportModal(false);
  };

  const filterHandler = async (query) => {
    setLoading2(true);
    setFilterQuery(query);
    setLoading2(false);
  };

  return (
    <Support
      loading={loading}
      loading2={loading2}
      supports={toJS(supportStore.supports)}
      goToViewMoreModal={goToViewMoreModal}
      ViewMoreModal={ViewMoreModal}
      closeModal={closeModal}
      filterHandler={filterHandler}
      createSupportModal={createSupportModal}
      goToCreateSupport={goToCreateSupport}
      isLoading={isLoading}
      supportData={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      setSearchQuery={setSearchQuery}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setFilterQuery={setFilterQuery}
    />
  );
};
export default SupportContainer;
